import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import scentabookbanner from '../../../assets/casestudy/scentabookbanner.webp';
import scentabook1stimg from '../../../assets/casestudy/scentabook1stimg.webp';
import scentabook2ndimg from '../../../assets/casestudy/scentabook2ndimg.webp';
import scentabook3rdimg from '../../../assets/casestudy/scentabook3rdimg.png';
import KumarPhotography from '../../../assets/img/KumarPhotoGraphy.png';
import Mongodbicon from '../../../assets/img/mongodbicon.svg';
import Nodeicon from '../../../assets/img/nodeicon.svg';
import Reacticon from '../../../assets/img/reacticon.svg';
import Expressicon from '../../../assets/img/expressicon.svg';
import ZEEQRCaseStudy from '../../../assets/casestudy/ZEEQRCaseStudy.webp';
import Ajtech2ndimg from '../../../assets/casestudy/ajtech2ndimg.webp';

const ScentaBook = () => {
    const caseStudiesB = [

    {
    image: ZEEQRCaseStudy,
    title: 'Zeeqr',
    category: 'Website Design',
    pagelink:'/zeeqr',
    link: 'https://zeeqr.com/',
  },
   {
    image: Ajtech2ndimg,
    title: 'AJTechIndustry',
    category: 'Website Design',
    pagelink:'/ajtechIndustry',
    link: 'https://agtechindustries.com/',
  },
];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys
      title="Scentabook"
      caseStudies={caseStudiesB} 
      subtitle="Elevating Spaces with Signature Scents"
      header='Elevating Spaces with Signature Scents'

      websiteUrl='https://scentabook.com/'
      industry="Luxury Scents & Aroma Solutions"
    services={servicesB}
      description={
        <>
          <span>Scenta Book </span> Scenta Book is an innovative brand that blends the world of literature with the evocative power of fragrance, crafting scents inspired by beloved books and timeless stories. To translate this unique concept into a compelling digital presence, we designed and developed a website that captures the essence of both storytelling and scent. The platform offers a sensory-rich, immersive experience that invites users to explore fragrances through the lens of literary imagination—seamlessly merging narrative with aroma to ignite emotion, memory, and curiosity.
        </>
      }
      objective={{
        heading: 'Building a User-Friendly Platform for Scentabook’s Customers',
        content: (
          <>
            <p className={styles.projectText}>
The objective of the Scent a Book website project was to create a captivating digital experience that reflects the brand’s unique fusion of storytelling and scent. The goal was to design an engaging, aesthetically rich e-commerce platform that brings literary-inspired fragrances to life, allowing users to explore perfumes through the emotional and imaginative lens of beloved books. This project aimed to align the digital presence with the brand’s creative and experiential identity, foster a deep connection with a niche community of readers and fragrance lovers, and drive growth through an intuitive and seamless online shopping journey.
            </p>

           
          </>
        ),
      }}
      process={{
        heading: "How We Built an Engaging and User-Friendly Website",
        content: (
          <>
            <p className={styles.projectText}>
      The project began with an in-depth exploration of Scent a Book’s brand philosophy, product concept, and target audience to fully grasp its unique blend of literature and fragrance. From this foundation, we mapped a user journey that emphasized emotional engagement, discovery, and simplicity. In the design phase, we focused on immersive storytelling, incorporating evocative visuals, elegant typography, and a palette inspired by vintage book covers and olfactory warmth. Development centered on building a responsive, fast, and user-friendly e-commerce platform that supports smooth navigation, secure checkout, and seamless mobile performance. Regular feedback sessions ensured creative alignment, and extensive testing was carried out to deliver a refined and immersive user experience at launch.
            </p>

         

           
          </>
        ),
      }}
      impact={{
        heading: 'The Positive Impact of Scentabook’s New Online Platform',
        content: (
          <>
            <p className={styles.projectText}>
      The launch of the Scent a Book website significantly enhanced the brand’s online presence, offering a distinctive and engaging way for customers to explore its literary-inspired fragrances. The thoughtfully designed interface and narrative-driven experience deepened emotional connection with users, while the streamlined e-commerce functionality encouraged smoother discovery and purchase flows. As a result, the website strengthened brand recognition within its niche audience, increased user engagement, and contributed to improved conversion rates—effectively bridging the gap between storytelling and scent in a memorable digital format.
            </p>
           
           
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
In conclusion, the Scent a Book website effectively brought the brand’s imaginative and sensory-rich concept to life through a compelling and immersive digital experience. By blending literary aesthetics with seamless functionality, the platform now stands as a powerful tool for storytelling, customer engagement, and online sales. The project not only elevated the brand’s online identity but also positioned Scent a Book for continued growth within the niche fragrance and lifestyle market.
            </p>
           
          </>
        ),
      }}
      heroImage={scentabookbanner} // Add the hero image
      projectImage={scentabook1stimg}
       projectImage2={scentabook2ndimg}
           projectImage3={scentabook3rdimg}
       // Add the project image
      technologies={[
           { name: 'MongoDB', icon: Mongodbicon },
        { name: 'Node.js', icon: Nodeicon },
        { name: 'React', icon: Reacticon },
        { name: 'Express.js', icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Nov 2024" // Add the launch date
    />
  );
};

export default ScentaBook;